(() => {
  if (window.MiravelCartDrawer) return;
  const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
  const parse = (html) => new DOMParser().parseFromString(html || '', 'text/html');
  const complete = (sections) => Boolean(
    parse(sections?.['cart-drawer']).querySelector('#CartDrawer .drawer__inner') &&
    parse(sections?.['cart-icon-bubble']).querySelector('.shopify-section')
  );
  const readSections = async (root) => {
    const response = await fetch(root + '?sections=' + sectionIds.join(','), {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' },
      signal: AbortSignal.timeout(15000)
    });
    if (!response.ok) throw Error('Cart sections unavailable');
    const sections = await response.json();
    if (!complete(sections)) throw Error('Cart sections incomplete');
    return sections;
  };
  const renderDirectly = (drawer, sections) => {
    const next = parse(sections['cart-drawer']).querySelector('#CartDrawer');
    const current = drawer.querySelector('#CartDrawer');
    if (!next || !current) throw Error('Cart drawer markup unavailable');
    current.replaceChildren(...next.childNodes);
    const icon = document.getElementById('cart-icon-bubble');
    const nextIcon = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
    if (icon && nextIcon) icon.replaceChildren(...nextIcon.childNodes);
  };
  const openDirectly = (drawer, button) => {
    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    const dialog = drawer.querySelector('.drawer__inner');
    dialog?.focus({ preventScroll: true });
    if (drawer.dataset.mvFallbackBound) return;
    drawer.dataset.mvFallbackBound = 'true';
    const close = () => {
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      button?.focus({ preventScroll: true });
    };
    drawer.addEventListener('click', (event) => {
      if (!event.target.closest('.drawer__close, #CartDrawer-Overlay')) return;
      event.preventDefault(); event.stopImmediatePropagation(); close();
    }, true);
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const visible = [...drawer.querySelectorAll('button, a[href], input, select, [tabindex="0"]')]
        .filter((element) => !element.disabled && element.getClientRects().length);
      const first = visible[0], last = visible[visible.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    });
  };
  window.MiravelCartDrawer = {
    async show(data, root, button) {
      const sections = complete(data?.sections) ? data.sections : await readSections(root);
      let drawer = document.querySelector('cart-drawer');
      if (!drawer) {
        const section = parse(sections['cart-drawer']).querySelector('#shopify-section-cart-drawer');
        if (!section) throw Error('Cart drawer section unavailable');
        document.body.append(section);
        drawer = section.querySelector('cart-drawer');
      }
      if (!drawer) throw Error('Cart drawer unavailable');
      drawer.classList.remove('is-empty');
      drawer.setActiveElement?.(button);
      if (typeof drawer.renderContents === 'function') {
        try { drawer.renderContents({ ...data, sections }, true); }
        catch (error) { console.warn('[Miravel] Recovering cart drawer rendering', error); renderDirectly(drawer, sections); }
      } else renderDirectly(drawer, sections);
      if (typeof drawer.open === 'function') {
        try { drawer.open(button); }
        catch (error) { console.warn('[Miravel] Recovering cart drawer opening', error); openDirectly(drawer, button); }
      } else openDirectly(drawer, button);
      return drawer;
    }
  };
})();
